import { useInfiniteQuery } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

import { CommentEntityType } from "..";

import * as Comments from "./getQueryKey";

interface UseCommentsForEntityParams {
  entityType: CommentEntityType;
  entityId: string;
}

export function getQueryKey(orgId: string, params: UseCommentsForEntityParams) {
  const { entityType, entityId } = params;
  return [...Comments.getQueryKey(orgId), "entity", entityType, entityId];
}

export function useCommentsForEntity(params: UseCommentsForEntityParams) {
  const { commentService } = useDomainServices();
  const { currentOrganization } = useAuth();
  const { entityType, entityId } = params;

  const orgId: string = currentOrganization?.org_id ?? "";

  return useInfiniteQuery({
    queryKey: getQueryKey(orgId, params),
    queryFn: async ({ pageParam, signal }) => {
      if (!orgId) {
        throw new Error("No organization selected");
      }

      return commentService.getCommentsForEntity(entityType, entityId, {
        orgId,
        pageToken: pageParam,
        abortSignal: signal,
      });
    },
    select: (data) => data.pages.flatMap((page) => page.items),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.next_token,
    enabled: currentOrganization !== null,
    // 1 minute. Chosen because comments are expected to update
    // more frequently than the default 5 min.
    staleTime: 60000,
  });
}
